import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

const apiDataProvider = new APIDataProvider();

export type TRequestSectionAnalysis = {
  sectionId: string;
  userId: string;
};

export interface ILectureAnalysisResponse {
  success: boolean;
  message?: string;
  sectionId?: string;
  requestAnalysis?: boolean;
}

export const requestSectionAnalysis = createAsyncThunk(
  '/lecture-analysis/requestAnalysis',
  async (data: TRequestSectionAnalysis) => {
    const path = `/lecture-analysis/requestAnalysis/${data.sectionId}?userId=${data.userId}`;
    const response = await apiDataProvider.post<
      TApiResponse<ILectureAnalysisResponse>
    >(path, {});

    return response.data;
  }
);
